import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {

  constructor() { }

  open(message: string) {

    const container = document.createElement('div');
    container.id = 'snackbar';

    const div = document.createElement('div');
    div.innerText = message;

    container.appendChild(div);
    document.body.appendChild(container);

    setTimeout(() => container.remove(), 3000);
  }
}
